// extracted by mini-css-extract-plugin
export default {"root":"ValueContainer_root__eCu1c","withAdornment":"ValueContainer_withAdornment__fTVcs"};